import { Stack, Skeleton, Typography } from '@mui/material';
import {
  StyledCardContainer,
  CardContainerIcon,
  ImageContainer,
} from './Filters.components';
import { getRandomNumberInclusive } from '@/utils';

export const SkeletonExperienceCard = () => {
  const labelWidth = getRandomNumberInclusive(40, 70);
  const descriptionWidth = getRandomNumberInclusive(60, 90);
  const emailWidth = getRandomNumberInclusive(100, 160);
  const phoneWidth = getRandomNumberInclusive(100, 160);

  return (
    <StyledCardContainer>
      <ImageContainer>
        <Skeleton variant="circular" width={40} height={40} />
      </ImageContainer>

      <Skeleton variant="text" width={`${labelWidth}%`} height={24} />
      <Skeleton variant="text" width={`${descriptionWidth}%`} height={18} />

      <Stack direction="row" alignItems="center" gap={1} mt={1}>
        <CardContainerIcon>
          <Skeleton variant="circular" width={18} height={18} />
        </CardContainerIcon>
        <Stack>
          <Skeleton variant="text" width={emailWidth} height={16} />
          <Typography fontSize={12} color="gray300">
            Email
          </Typography>
        </Stack>
      </Stack>

      <Stack direction="row" alignItems="center" gap={1} mt={1}>
        <CardContainerIcon>
          <Skeleton variant="circular" width={18} height={18} />
        </CardContainerIcon>
        <Stack>
          <Skeleton variant="text" width={phoneWidth} height={16} />
          <Typography fontSize={12} color="gray300">
            Phone
          </Typography>
        </Stack>
      </Stack>
    </StyledCardContainer>
  );
};
